// Must stay first: Firebase has to initialise before anything touches it.
import './firebaseApp';

// HEADS UP: this is the change that makes cs106a website
// different than code in place. It should only be
// set to cs106a in the cs106a branch.
// import {Router} from 'csbridge/Router'
// import { Router } from 'cs106a/Router';
import {bootstrapCipApp} from './bootstrapCipApp';
import {CipxLoadingPage} from 'components/loading/CipxLoadingPage';

// Everything around the render — the stale-chunk guard, the production
// console interception and error forwarding, the service workers, the slow
// cold-load timer — lives in `bootstrapCipApp` so this entrypoint and PAI's
// cannot drift apart. See `bootstrapCipApp.tsx`.
bootstrapCipApp({
  webApp: 'cip-webapp',
  components: {
    courseOverrides: {
      // cipx doesn't teach Karel, so it swaps the Karel standard loader for
      // an on-brand animated sun. Every other course keeps the default.
      cipx: {LoadingPage: CipxLoadingPage},
    },
  },
});
